import {
  createDocumentDataFieldGroup,
  FieldGroupModel,
} from '../../models/extraction-models/extraction-models';
import { FieldType } from '@ps-gui/shared-utils';
import { Validations } from '@ps-gui/ui';

export const AuftragESESections: FieldGroupModel[] = [
  createDocumentDataFieldGroup(),
  {
    key: 'ese_auftragsdaten',
    label: 'Auftragsdaten',
    index: 0,
    fieldModels: [
      {
        key: 'ese_schadennumer',
        label: {
          text: 'Schadennumer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 1,
        validators: [Validations.required()],
      },
      {
        key: 'ese_teilschadennummer',
        label: {
          text: 'Teilschadennummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 2,
      },
      {
        key: 'ese_schadendatum',
        label: {
          text: 'Schadendatum',
          genus: 'N',
        },
        type: FieldType.DATE,
        index: 3,
        validators: [Validations.required()],
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'ese_sachbearbeiter',
    label: 'Sachbearbeiter',
    index: 4,
    fieldModels: [
      {
        key: 'ese_sachbearbeiter_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 5,
        validators: [Validations.required()],
      },
      {
        key: 'ese_sachbearbeiter_nachname',
        label: {
          text: 'Nachname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 6,
        validators: [Validations.required()],
      },
      {
        key: 'ese_sachbearbeiter_email',
        label: {
          text: 'E-Mail',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 7,
        validators: [Validations.required()],
      },
      {
        key: 'ese_sachbearbeiter_telefon',
        label: {
          text: 'Telefon',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 8,
        validators: [Validations.required()],
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'ese_betroffene_person',
    label: 'Betroffene Person',
    index: 9,
    fieldModels: [
      {
        key: 'ese_betroffene_person_geschlecht',
        label: {
          text: 'Geschlecht',
          genus: 'N',
        },
        type: FieldType.DROPDOWN,
        options: [
          {
            value: 'U',
            label: 'keine Angabe',
          },
          {
            value: 'M',
            label: 'Männlich',
          },
          {
            value: 'W',
            label: 'Weiblich',
          },
          {
            value: 'D',
            label: 'Divers',
          },
        ],
        index: 10,
      },
      {
        key: 'ese_betroffene_person_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 11,
        validators: [Validations.required()],
      },
      {
        key: 'ese_betroffene_person_nachname',
        label: {
          text: 'Nachname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 12,
        validators: [Validations.required()],
      },
      {
        key: 'ese_betroffene_person_geburtsdatum',
        label: {
          text: 'Geburtsdatum',
          genus: 'N',
        },
        type: FieldType.DATE,
        index: 13,
      },
      {
        key: 'ese_betroffene_person_strasse_hausnummer',
        label: {
          text: 'Straße und Hausnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 14,
        validators: [Validations.required()],
      },
      {
        key: 'ese_betroffene_person_postleitzahl',
        label: {
          text: 'Postleitzahl',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 16,
        validators: [Validations.required()],
      },
      {
        key: 'ese_betroffene_person_ort',
        label: {
          text: 'Ort',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 17,
      },
      {
        key: 'ese_betroffene_person_email',
        label: {
          text: 'E-Mail Adresse',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 18,
      },
      {
        key: 'ese_betroffene_person_telefonnummer',
        label: {
          text: 'Telefonnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 18,
      },
      {
        key: 'ese_betroffene_person_beruf',
        label: {
          text: 'Beruf',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 19,
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'ese_anwalt',
    label: 'Anwalt',
    index: 20,
    fieldModels: [
      {
        key: 'ese_anwalt_fallnummer',
        label: {
          text: 'Fallnummer / Aktenzeichen',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 21,
      },
      {
        key: 'ese_anwalt_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 22,
      },
      {
        key: 'ese_anwalt_nachname',
        label: {
          text: 'Nachname',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 23,
      },
      {
        key: 'ese_anwalt_strasse_hausnummer',
        label: {
          text: 'Straße und Hausnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 24,
      },
      {
        key: 'ese_anwalt_postleitzahl',
        label: {
          text: 'Postleitzahl',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 26,
      },
      {
        key: 'ese_anwalt_ort',
        label: {
          text: 'Ort',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 27,
      },
      {
        key: 'ese_anwalt_email',
        label: {
          text: 'E-Mail Adresse',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 28,
      },
      {
        key: 'ese_anwalt_telefonnummer',
        label: {
          text: 'Telefonnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 29,
      },
      {
        key: 'ese_anwalt_fax',
        label: {
          text: 'Fax',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 30,
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'ese_vertretungsberechtigte_person',
    label: 'Vertretungsberechtigte Person',
    index: 31,
    fieldModels: [
      {
        key: 'ese_vertretungsberechtigte_person_typ',
        label: {
          text: 'Typ',
          genus: 'M',
        },
        type: FieldType.DROPDOWN,
        options: [
          {
            value: 'HEIR',
            label: 'Erbe/Erbin',
          },
          {
            value: 'PARENT',
            label: 'Erziehungsberechtigte/r',
          },
          {
            value: 'AUTHORIZED',
            label: 'Bevollmächtigte/r',
          },
        ],
        index: 32,
      },

      {
        key: 'ese_vertretungsberechtigte_person_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 33,
      },
      {
        key: 'ese_vertretungsberechtigte_person_nachname',
        label: {
          text: 'Nachname',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 34,
      },
      {
        key: 'ese_vertretungsberechtigte_person_strasse_hausnummer',
        label: {
          text: 'Straße und Hausnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 35,
      },
      {
        key: 'ese_vertretungsberechtigte_person_postleitzahl',
        label: {
          text: 'Postleitzahl',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 37,
      },
      {
        key: 'ese_vertretungsberechtigte_person_ort',
        label: {
          text: 'Ort',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 38,
      },
      {
        key: 'ese_vertretungsberechtigte_person_telefonnummer',
        label: {
          text: 'Telefonnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 39,
      },
      {
        key: 'ese_vertretungsberechtigte_person_email',
        label: {
          text: 'E-Mail Adresse',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 40,
      },
    ],
    type: 'fieldGroupModel',
  },
];
